
import { defineComponent } from 'vue'
import { ICategory } from './../type'
import addBranchSlugToUrl from '@/helper/addBranchSlugToUrl'

export default defineComponent({
    props: ['category', 'isActive'],
    name: 'Category',
    data () {
        return {
            categories: [] as ICategory[],
        }
    },
    computed: {
        categoriesSliced () {
            return this.categories.slice(0, 4)
        },
        showOthers () {
            return this.categories.length > 4
        },
        storeTitle () {
            return window.config.getBranchSlug()
        },
    },
    methods: {
        addStoreToUrl: addBranchSlugToUrl,
        isWideScreen () {
            return !window.matchMedia('(max-width: 980px)').matches
        },
    },
    created () {
        this.categories = this.$props.category.category as ICategory[]
    },
    // updated () {
    //     this.$nextTick(function () {
    //         this.$emit('category-updated');
    //     });
    // },
    // beforeDestroy() {
    //     if (this.xhr) {
    //         this.xhr.abort();
    //     }
    // },
})
